import { render, staticRenderFns } from "./BaseFullScreenModal.vue?vue&type=template&id=08ba60e2"
import script from "./BaseFullScreenModal.vue?vue&type=script&lang=js"
export * from "./BaseFullScreenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports